import React from 'react'
import SyncButton from '../../ui/sync-button'
import {regHolderBasePath} from '../../reg-holder'

const PersonnelSyncButtons = ({regHolder, onComplete}) => (
  <SyncButton
    steps={[
      {
        syncPath: regHolderBasePath(regHolder) + '/gov-registrations/sync',
        text: 'Pulling records from government',
      },
      {
        syncPath: regHolderBasePath(regHolder) + '/sync-personnel'
      }
    ]}
    onComplete={onComplete}
  />
)

export default PersonnelSyncButtons



// WEBPACK FOOTER //
// ./src/personnel/views/sync-buttons.jsx